let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cHGld")).then(() => parcelRequire('3XrVw'));